/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { FileModle } from "@eisinc/App/EditorTemplates/BynderSelectorField";
import { BynderSelectorFieldDefinition, CustomFieldDefinition } from "@eisinc/CustomFieldDefinition";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { LazyImage, Typography } from "@insite/mobius/index";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import * as React from "react";

const enum fields {
    title = 'Bynder File Selector',
    files = 'files',
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.files]: FileModle[];
    };
}

type Props = OwnProps;

type BynderWidgetProps = Props & WidgetProps;

const BynderPageWidget: React.FC<BynderWidgetProps> = ({
    fields,
}) => {
    return (
        <StyledWrapper>
            {
                fields.title && <Typography>{fields.title}</Typography>
            }
            {
                fields.files?.map(file => {
                    return (
                        <StyledWrapper key={uniqueId()}>
                            <LazyImage
                                src={file.derivatives.webImage}
                                altText="webImage"
                            />
                        </StyledWrapper>
                    );
                })
            }
        </StyledWrapper>
    );
};

const definition: WidgetDefinition<CustomFieldDefinition> = {
    group: "Common" as any,
    fieldDefinitions: [
        {
            name: fields.title,
            displayName: "Title",
            editorTemplate: "TextField",
            fieldType: "General",
            defaultValue: "",
        },
        {
            name: fields.files,
            displayName: "Select File",
            editorTemplate: "BynderSelectorField",
            fieldType: "General",
            defaultValue: [] as any,
        },
    ] as any,
};

const widgetModule: WidgetModule<CustomFieldDefinition> = {
    component: BynderPageWidget,
    definition,
};

export default widgetModule;